// Tienen que coincidir con NewsController y NewsAttachment del backend
export const MAX_FILES = 10;
export const MAX_UPLOAD_BYTES = 38 * 1024 * 1024;
export const VALID_EXTENSIONS = ["pdf", "jpg", "jpeg", "png", "webp", "gif", "mp4", "webm"];

const IMAGE_TYPES = ["jpg", "jpeg", "png", "webp", "gif"];
const VIDEO_TYPES = ["mp4", "webm"];

export function isImage(file_type) {
  return IMAGE_TYPES.includes(file_type);
}

export function isVideo(file_type) {
  return VIDEO_TYPES.includes(file_type);
}

export function getExtension(name) {
  const parts = String(name || "").split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
}

export function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") + " MB";
}

// "Y-m-d H:i:s" -> "dd/mm/yyyy hh:mm"
export function formatDateTime(date) {
  if (!date) return "";
  const [day_part, time_part] = date.split(" ");
  const [year, month, day] = day_part.split("-");
  return `${day}/${month}/${year} ${time_part.substr(0, 5)}`;
}

// Id del video si el link es de YouTube (watch, youtu.be, shorts, embed o live), si no null
export function getYoutubeId(url) {
  const match = String(url || "").match(/^https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{11})(?:[?&#/].*)?$/);
  return match ? match[1] : null;
}
